import React from "react"

import { sLayout } from "../styled/layout"
import { sTags } from "../styled/tags"
import { getCategoryUrl } from "../utilities"

const Tags = ({ tags }) => (
  <sTags.List>
    {tags.map(tag => (
      <sTags.Item key={tag.slug}>
        <sLayout.Button to={getCategoryUrl(tag.slug)}>
          <span>{tag.name}</span>
        </sLayout.Button>
      </sTags.Item>
    ))}
  </sTags.List>
)

export default Tags
